import {Navigate, Outlet} from "react-router";
import {AUTH_TOKEN} from "../config";

export const PublicRouter = () => {
    const access_token  = localStorage.getItem(AUTH_TOKEN);
    return !access_token ? <Outlet/> : <Navigate to={'/home'}/>;
}
